<template>
    <v-container fluid class="pa-0 ma-0">
        <v-card elevation="0" color="transparent" class="px-5 py-1">

            <v-row v-if="mostrarFiltro" class="d-flex align-center wrap">

                <v-col cols="12">
                    <v-btn @click="adicionarFiltro" color="#4682B4" small class="white--text mb-3">
                        Adicionar Filtro
                        <v-icon right small>mdi-plus</v-icon>
                    </v-btn>
                </v-col>

                <template v-for="(filtro, index) in filtros">

                    <v-col :key="`tipo-${filtro.id}`" cols="12" sm="12" md="3" class="py-1">
                        <v-select v-model="filtro.tipo" :items="tiposDisponiveis(index)" label="Selecionar Campo" dense
                            solo-inverted hide-details class="compact-field" @change="onFiltroChange(index)"></v-select>
                    </v-col>

                    <v-col v-if="filtro.tipo === 'Período'" :key="`data-ini-${filtro.id}`" cols="12" sm="6" md="3"
                        class="py-1">
                        <v-menu v-model="filtro.dataInicialAberto" :close-on-content-click="false"
                            transition="scale-transition" offset-y min-width="auto">
                            <template #activator="{ on, attrs }">
                                <v-text-field v-model="filtro.dataInicialFormatada" label="Data Inicial" dense
                                    solo-inverted readonly hide-details v-bind="attrs" v-on="on"
                                    class="compact-field"></v-text-field>
                            </template>
                            <v-date-picker v-model="filtro.dataInicial" no-title @input="
                                filtro.dataInicialAberto = false;
                            filtro.dataInicialFormatada = formatDate(filtro.dataInicial);
                            "></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col v-if="filtro.tipo === 'Período'" :key="`data-fim-${filtro.id}`" cols="12" sm="6" md="3"
                        class="py-1">
                        <v-menu v-model="filtro.dataFinalAberto" :close-on-content-click="false"
                            transition="scale-transition" offset-y min-width="auto">
                            <template #activator="{ on, attrs }">
                                <v-text-field v-model="filtro.dataFinalFormatada" label="Data Final" dense solo-inverted
                                    readonly hide-details v-bind="attrs" v-on="on" class="compact-field"></v-text-field>
                            </template>
                            <v-date-picker v-model="filtro.dataFinal" no-title @input="
                                filtro.dataFinalAberto = false;
                            filtro.dataFinalFormatada = formatDate(filtro.dataFinal);
                            "></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col v-if="['Departamento', 'Categoria', 'Status'].includes(filtro.tipo)"
                        :key="`select-val-${filtro.id}`" cols="12" sm="6" md="6" class="py-1">
                        <v-select v-model="filtro.valor" :items="getOpcoesPorTipo(filtro.tipo)"
                            :label="'Selecione ' + filtro.tipo" dense solo-inverted hide-details class="compact-field"
                            :loading="filtro.tipo === 'Departamento' && loadingEntidades"></v-select>
                    </v-col>

                    <v-col v-if="['Solicitante', 'Responsável'].includes(filtro.tipo)" :key="`text-val-${filtro.id}`"
                        cols="12" sm="6" md="6" class="py-1">
                        <v-text-field v-model="filtro.valor" :label="'Nome do ' + filtro.tipo" dense solo-inverted
                            hide-details class="compact-field"></v-text-field>
                    </v-col>

                    <v-col :key="`btn-del-${filtro.id}`" cols="12" sm="2" md="1" class="py-1 d-flex align-center">
                        <v-btn @click="removerFiltro(index)" color="error" icon small>
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </v-col>

                    <v-col cols="12" :key="`divider-${filtro.id}`" class="pa-0"><v-divider
                            class="my-1"></v-divider></v-col>
                </template>
            </v-row>

            <v-card-actions class="justify-end pt-4">
                <v-btn @click="alternarVisibilidade" text color="primary" small>
                    {{ mostrarFiltro ? "Ocultar" : "Mostrar Filtros" }}
                    <v-icon right>{{ mostrarFiltro ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn @click="limparFiltro" color="grey" text small v-if="mostrarFiltro">
                    Limpar
                </v-btn>

                <v-btn @click="filtrar" color="#4682B4" class="white--text" small v-if="mostrarFiltro">
                    Filtrar
                    <v-icon right small>mdi-filter</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import Glpi from "@/services/glpi";

export default {
    name: "FiltroDinamicoGLPI",

    data() {
        return {
            mostrarFiltro: true,
            loadingEntidades: false,
            filtros: [],

            tiposDeFiltros: [
                "Departamento",
                "Categoria",
                "Solicitante",
                "Responsável",
                "Período",
                "Status",
            ],

            // Inicializa arrays vazios para evitar erros de renderização
            departamentos: [],
            categorias: ["Hardware", "Software", "Rede", "Acesso", "Dúvida", "Impressora"],
            statusOptions: ["Novo", "Em atendimento (atribuído)", "Planejado", "Pendente", "Solucionado", "Fechado"],
        }; // <--- FECHA O OBJETO DO RETURN (Ponto e vírgula opcional, mas chave obrigatória)
    }, // <--- FECHA A FUNÇÃO DATA E COLOCA VÍRGULA (CRUCIAL!)

    mounted() {
        this.carregarEntidades();
        // Adiciona uma linha inicial se não houver nenhuma
        if (this.filtros.length === 0) {
            this.adicionarFiltro();
        }
    },

    methods: {
        async carregarEntidades() {
            this.loadingEntidades = true;
            try {
                const response = await Glpi.listar_entidades();
                if (response.data && Array.isArray(response.data)) {
                    this.departamentos = response.data.map((e) => e.completename);
                }
            } catch (error) {
                console.error("Erro ao carregar entidades:", error);
                this.departamentos = ["TI", "RH", "Financeiro"];
            } finally {
                this.loadingEntidades = false;
            }
        },

        tiposDisponiveis(index) {
            const tiposSelecionados = this.filtros
                .filter((_, i) => i !== index)
                .map((f) => f.tipo)
                .filter(Boolean);

            return this.tiposDeFiltros.filter(
                (tipo) => !tiposSelecionados.includes(tipo)
            );
        },

        getOpcoesPorTipo(tipo) {
            switch (tipo) {
                case "Departamento": return this.departamentos;
                case "Categoria": return this.categorias;
                case "Status": return this.statusOptions;
                default: return [];
            }
        },

        adicionarFiltro() {
            this.filtros.push({
                id: Date.now(), // ID único para a key do v-for
                tipo: null,
                valor: null,
                dataInicial: null,
                dataFinal: null,
                dataInicialAberto: false,
                dataFinalAberto: false,
                dataInicialFormatada: null,
                dataFinalFormatada: null,
            });
        },

        removerFiltro(index) {
            this.filtros.splice(index, 1);
        },

        onFiltroChange(index) {
            const filtro = this.filtros[index];
            filtro.valor = null;
            filtro.dataInicial = null;
            filtro.dataFinal = null;
            filtro.dataInicialFormatada = null;
            filtro.dataFinalFormatada = null;
        },

        alternarVisibilidade() {
            this.mostrarFiltro = !this.mostrarFiltro;
        },

        limparFiltro() {
            this.filtros = [];
            this.adicionarFiltro();
            this.$emit("filtrar", {});
        },

        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        filtrar() {
            const filterValues = {
                periodoInicial: this.filtros.find((f) => f.tipo === "Período")?.dataInicial || null,
                periodoFinal: this.filtros.find((f) => f.tipo === "Período")?.dataFinal || null,
                departamento: this.filtros.find((f) => f.tipo === "Departamento")?.valor || null,
                categoria: this.filtros.find((f) => f.tipo === "Categoria")?.valor || null,
                status: this.filtros.find((f) => f.tipo === "Status")?.valor || null,
                solicitante: this.filtros.find((f) => f.tipo === "Solicitante")?.valor || null,
                responsavel: this.filtros.find((f) => f.tipo === "Responsável")?.valor || null,
            };
            this.$emit("filtrar", filterValues);
        },
    },
};
</script>

<style scoped>
.compact-field {
    font-size: 14px;
}

/* Força altura menor nos inputs do Vuetify */
::v-deep .v-input__control {
    min-height: 40px !important;
}

::v-deep .v-input__slot {
    min-height: 40px !important;
    margin-bottom: 0;
}
</style>